// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import theme from '../../shared/theme';
import MetadataView from '../metadata/metadata-view';
import EditorLevel from '../models/editor-level';
import LinkedTaskRecords from '../fields/linked-task-records';
import { UniversalMediaUploaderProvider } from '../../components/providers/universal-media-uploader-provider';
import ElementListView from './element-list-view';

export default class RecordEditorView extends React.Component {
  static propTypes = {
    addMode: PropTypes.bool.isRequired,
    editing: PropTypes.bool.isRequired,
    level: PropTypes.instanceOf(EditorLevel).isRequired,
    mapVisible: PropTypes.bool.isRequired,
    // navigationController: PropTypes.instanceOf(NavigationController),
    onGeometryChange: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onLinkedRecordSelect: PropTypes.func.isRequired,
    onLinkedRecordNew: PropTypes.func.isRequired,
    onLinkedRecordOpen: PropTypes.func.isRequired,
    onHyperlinkClick: PropTypes.func.isRequired,
    onRepeatableNavigate: PropTypes.func.isRequired,
    onSectionNavigate: PropTypes.func.isRequired,
    onFocusChange: PropTypes.func.isRequired,
    onProjectChange: PropTypes.func.isRequired,
    onAssignmentChange: PropTypes.func.isRequired,
    onStatusChange: PropTypes.func.isRequired,
    onMediaAdd: PropTypes.func.isRequired,
    onMediaRemove: PropTypes.func.isRequired,
    onUploadingChange: PropTypes.func,
    specialInstructions: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        changes: PropTypes.arrayOf(PropTypes.shape({
          attributeName: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired,
        })),
      }),
    ),
  };

  // for media queries
  constructor(props, context) {
    super(props, context);

    this.state = {
      matchesMd: window.matchMedia('(max-width: 1400px)').matches,
      matchesSm: window.matchMedia('(max-width: 960px)').matches,
    };
  }

  componentDidMount() {
    const handlerMd = (e) => this.setState({ matchesMd: e.matches });
    window.matchMedia('(max-width: 1400px)').addEventListener('change', handlerMd);

    const handlerSm = (e) => this.setState({ matchesSm: e.matches });
    window.matchMedia('(max-width: 960px)').addEventListener('change', handlerSm);
  }

  componentWillUnmount() {
    window.matchMedia('(max-width: 1400px)').removeEventListener('change', this.handlerMd);
    window.matchMedia('(max-width: 960px)').removeEventListener('change', this.handlerSm);
  }
  // END for media queries

  render() {
    const { styles } = RecordEditorView;
    const {
      editing,
      level,
      mapVisible,
      onSectionNavigate,
      onFieldChange,
      onLinkedRecordSelect,
      onLinkedRecordNew,
      onLinkedRecordOpen,
      onHyperlinkClick,
      onRepeatableNavigate,
      onMediaAdd,
      onMediaRemove,
      onFocusChange,
    } = this.props;

    // styling for media queries
    const fieldContainerStyle = {
      width: (() => {
        switch (true) {
          case mapVisible && this.state.matchesSm:
            return 700;
          case mapVisible && this.state.matchesMd:
            return 560;
          case mapVisible:
            return 700;
          default:
            return '100%';
        }
      })(),
      flex: mapVisible ? 'unset' : 'none',
    };

    const containerStyle = {
      width: (() => {
        switch (true) {
          case mapVisible && this.state.matchesSm:
            return 700;
          case mapVisible && this.state.matchesMd:
            return 560;
          case mapVisible:
            return 700;
          default:
            return '100%';
        }
      })(),
    };
    // END styling for media queries

    const {
      feature, record, rootElement, valuesForConditions,
    } = level;

    return (
      <UniversalMediaUploaderProvider onUploadingChange={this.props.onUploadingChange}>
        <div className={styles.container} style={containerStyle}>
          <div className={styles.fieldContainer} style={fieldContainerStyle}>
            {this.renderMetadataView()}

            {this.renderLinkedRecords()}

            <ElementListView
              record={record}
              feature={feature}
              editing={editing}
              onDrillDownSectionClick={onSectionNavigate}
              onFieldChange={onFieldChange}
              onLinkedRecordSelect={onLinkedRecordSelect}
              onLinkedRecordNew={onLinkedRecordNew}
              onLinkedRecordOpen={onLinkedRecordOpen}
              onHyperlinkClick={onHyperlinkClick}
              onRepeatableClick={onRepeatableNavigate}
              onMediaAdd={onMediaAdd}
              onMediaRemove={onMediaRemove}
              onFocusChange={onFocusChange}
              rootElement={rootElement}
              valuesForConditions={valuesForConditions}
            />
          </div>
        </div>
      </UniversalMediaUploaderProvider>
    );
  }

  renderMetadataView() {
    if (this.props.level.isSectionLevel || this.props.level.isRepeatableIndexLevel) {
      return null;
    }

    return (
      <MetadataView
        editing={this.props.editing}
        addMode={this.props.addMode}
        feature={this.props.level.feature}
        record={this.props.level.record}
        visible
        onProjectChange={this.props.onProjectChange}
        onAssignmentChange={this.props.onAssignmentChange}
        onStatusChange={this.props.onStatusChange}
        onGeometryChange={this.props.onGeometryChange}
      />
    );
  }

  renderLinkedRecords() {
    const { level, specialInstructions } = this.props;
    return (
      <LinkedTaskRecords recordId={level.record.id} specialInstructions={specialInstructions} />
    );
  }

  isRepeatable() {
    return this.props.level.feature.repeatableElement != null;
  }
}

const styles = cssInJS({
  container: {
    transition: 'all 80ms ease',
    display: 'flex',
    height: '100%',
    backgroundColor: '#fff',
    fontFamily: theme.fontFamily,
  },

  fieldContainer: {
    minWidth: 560,
    overflow: 'auto',
    transition: 'all 80ms ease',
    backgroundColor: '#fff',
    boxShadow: '0px -4px 50px 3px rgba(0,0,0,0.2)',
    zIndex: 1,
  },

  mapContainer: {
    transition: 'all 80ms ease',
  },

  map: {
    height: '100%',
  },
});

RecordEditorView.styles = styles;
